<template>
    <CaPerEntityComponent v-bind="$props" :entity="GENERAL_OPTION" />
</template>

<script>
import CaPerEntityComponent from "./CaPerEntityComponent.vue";
import { GENERAL_OPTION } from "../../utils/stats/revenueEntities.js";

export default {
    props: {
        grid: {
            required: true,
            type: Object,
        },
        filters: {
            required: true,
            type: Object,
        },
    },
    computed: {
        GENERAL_OPTION() {
            return GENERAL_OPTION;
        },
    },
    components: {
        CaPerEntityComponent,
    },
};
</script>
